import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { digitalCardsReducer } from "./digital-cards.reducer";
import { DigitalCardsEffects } from "./digital-cards.effects";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature("digitalCards", digitalCardsReducer),
    EffectsModule.forFeature([DigitalCardsEffects]),
  ],
})
export class DigitalCardsModule {}
